<template>
  <a-modal v-model="visible" title="Edit Hostel Event" :footer="null">
    <a-form :form="form" @submit="handleSubmit">
      <div class="row">
        <div class="col-md-5 col-12">
          <a-form-item label="Event Name">
            <a-input
              placeholder="e.g. Morning Wake-up"
              v-decorator="['name', { rules: [{ required: true, message: 'Please enter event name' }] }]"
            />
          </a-form-item>
        </div>
        <div class="col-md-3 col-12">
          <a-form-item label="Code">
            <a-input
              placeholder="e.g. WAKE"
              v-decorator="['code', { rules: [{ required: true, message: 'Please enter code' }] }]"
            />
          </a-form-item>
        </div>
        <div class="col-md-4 col-12">
          <a-form-item label="Hostel">
            <a-select v-decorator="['hostel_id', { initialValue: null }]">
              <a-select-option :value="null">All Hostels (Global)</a-select-option>
              <a-select-option v-for="h in hostels" :key="h.id" :value="h.id">
                {{ h.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-12">
          <a-form-item label="Default Start Time">
            <a-time-picker
              format="HH:mm"
              style="width: 100%"
              v-decorator="['default_start_time', { rules: [{ required: true, message: 'Please select start time' }] }]"
            />
          </a-form-item>
        </div>
        <div class="col-md-6 col-12">
          <a-form-item label="Default End Time">
            <a-time-picker
              format="HH:mm"
              style="width: 100%"
              v-decorator="['default_end_time', { rules: [{ required: true, message: 'Please select end time' }] }]"
            />
          </a-form-item>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-12">
          <a-form-item label="Sort Order">
            <a-input-number
              style="width: 100%"
              v-decorator="['sort_order']"
            />
          </a-form-item>
        </div>
        <div class="col-md-6 col-12">
          <a-form-item label="Status">
            <a-select v-decorator="['status']">
              <a-select-option :value="1">Active</a-select-option>
              <a-select-option :value="0">Inactive</a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </div>

      <div class="text-right mt-4">
        <a-button class="mr-2" @click="handleCancel">Cancel</a-button>
        <a-button type="primary" html-type="submit" :loading="loading">Update Event</a-button>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import moment from 'moment'

export default {
  name: 'EditHostelEventModal',
  props: {
    hostels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      recordId: null,
    }
  },
  mounted() {
    this.$eventBus.$on('openEditHostelEvent', record => {
      this.recordId = record.id
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: record.name,
          code: record.code,
          hostel_id: record.hostel_id || null,
          default_start_time: moment(record.default_start_time, 'HH:mm:ss'),
          default_end_time: moment(record.default_end_time, 'HH:mm:ss'),
          sort_order: record.sort_order,
          status: record.status,
        })
      })
    })
  },
  beforeDestroy() {
    this.$eventBus.$off('openEditHostelEvent')
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          const payload = {
            ...values,
            default_start_time: values.default_start_time.format('HH:mm'),
            default_end_time: values.default_end_time.format('HH:mm'),
          }

          this.$http.patch(`/api/hostel/event/${this.recordId}`, payload)
            .then(() => {
              this.loading = false
              this.visible = false
              this.$emit('onEdited')
              this.$notification.success({
                message: 'Success',
                description: 'Hostel event updated successfully.',
              })
            })
            .catch(error => {
              this.loading = false
              this.$neoNotify.error(error)
            })
        }
      })
    },
  },
}
</script>
